import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";
import { formatPrice } from "@/lib/api";

const COUNTRY_CENTERS = {
  MA: [33.0, -7.5],
  DZ: [36.0, 2.8],
  TN: [35.5, 10.0],
  ALL: [33.5, 2.5],
};

const makeIcon = (label, boosted) =>
  L.divIcon({
    className: "",
    html: `<div class="aqarate-marker ${boosted ? "boosted" : ""}">${label}</div>`,
    iconSize: [80, 28],
    iconAnchor: [40, 14],
  });

export const MapView = ({ listings, country = "ALL", height = "70vh" }) => {
  const center = COUNTRY_CENTERS[country] || COUNTRY_CENTERS.ALL;
  const zoom = country === "ALL" ? 5 : 6;
  const valid = listings.filter((l) => l.latitude != null && l.longitude != null);

  return (
    <div className="rounded-2xl overflow-hidden border border-[#E5E5E5]" style={{ height }}>
      <MapContainer center={center} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {valid.map((l) => {
          const label = formatPrice(l.price, l.currency, l.type).replace(/\s/g, " ");
          return (
            <Marker
              key={l.id}
              position={[l.latitude, l.longitude]}
              icon={makeIcon(label, l.is_boosted)}
            >
              <Popup>
                <div className="w-56">
                  <img src={l.photos?.[0]} alt={l.title} className="w-full h-28 object-cover rounded-md mb-2" />
                  <Link to={`/listings/${l.id}`} className="font-heading font-medium text-sm hover:text-[#D6202C]">
                    {l.title}
                  </Link>
                  <div className="text-xs text-muted-foreground mt-1">{l.city}</div>
                  <div className="font-heading font-semibold text-base text-[#D6202C] mt-1">
                    {formatPrice(l.price, l.currency, l.type)}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};
